<template>
  <div>
    <b-form-select v-model="selected" :options="options">
      <template #first>
        <b-form-select-option :value="null" disabled>{{placeholder}}</b-form-select-option>
      </template>
    </b-form-select>
  </div>
</template>

<script>

export default {
  name: "sale-order-type-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        { value: 'brs', text: this.lodash.upperFirst(this.$t('sale_notes.types.brs')) },
        { value: 'unload', text: this.lodash.upperFirst(this.$t('sale_notes.types.unload')) },
        { value: 'local_market', text: this.lodash.upperFirst(this.$t('sale_notes.types.local_market')) },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val){
      this.selected = val || null
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
